import React, { useEffect, useState } from 'react'
import { useForm } from '../../../hooks/useForm';
import { useAxiosPost, useAxiosPost2 } from '../../../hooks/useAxiosPost';
import { useTranslation } from 'react-i18next';
import ReglasPopup from '../../popup/reglaspopup'

export default function ComentariosForm({ guid, friendly="" }) {

    const [t, i18n] = useTranslation("detail_blog");

    const [count, setCount] = React.useState(0);
    const [correo, setCorreo] = useState('');
    const [isReglasPopupOpen, setReglasPopupOpen] = useState(false);

    const [isValidEmail, setIsValidEmail] = useState(true);

    const onInputChangeCorreo = (e) => {
        setCorreo(e.target.value);
      };

    const i = 0;

    const [formSubmitted, setFormSubmitted] = useState( false )
    const { formState, onInputChange, Nombre, Procedencia, Comentario, Email , onResetForm} = useForm({
        Nombre: '',
        Procedencia: '',
        Comentario: '',
        Email: correo
    });

    const openReglasPopup = () => {
        setReglasPopupOpen(true);
      };
    
      const closeReglasPopup = () => {
        setReglasPopupOpen(false);
      };

    const handleFormSubmitted = (value) => {
        setFormSubmitted(value);
    };

    const handleEmailChange = (event) => {
        const { value } = event.target;
        setCorreo(value);
    
        // Validar el formato del correo electrónico
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setIsValidEmail(emailRegex.test(value));
      };
    

    const { data, isLoading, error} = useAxiosPost(  
        formSubmitted ? '/comments/new' : null, 
        { Nombre, Procedencia, Comentario, AceptTerminos: 1, Email: correo, id: guid  },
        handleFormSubmitted);

    //const { data2, isLoading2, error2} = useAxiosPost2(  
           // formSubmitted ? 'https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/email/send-email-comment' : null, 
           // { fromName: 'comentarios.ricardosalinas', from:'comentarios.ricardosalinas@gruposalinas.com.mx', to:'comentarios.ricardosalinas@gruposalinas.com.mx', subject: 'Nuevo comentario al Blog', body: '<p>Nuevo comentario al blog: <b>'+friendly+"</b></p><p>" +Nombre +"<br/>" + correo +"<br/>" + Procedencia + '</p><br/><p>Comentario: <br/>' + Comentario+ '</p>', isBodyHtml: true},
           // handleFormSubmitted);

    const onFormSubmit = ( event ) => {
        event.preventDefault();

        if(Nombre.length <= 1)
        {
            alert((t('comments.v_nombre')));
            return;
        }
            
        if(correo.length <= 1)
        {
            alert((t('comments.v_email')));
            return;
        }
        
        if(Comentario.length <= 1)
        {
            alert((t('comments.v_comentario')));
            return;
        }

        if (isValidEmail) {
            console.log('Correo electrónico válido:', correo);
          } else {
            alert((t('comments.v_valido')));
            return;
          }

        setFormSubmitted(true);


    }

    useEffect(() => {

        if(data === undefined) {
            onResetForm();
        }

    }, [data]);

    return (
        <div className="coment_form">
                <div className="coment_form_title">
                    <h2>
                        {(t('comments.have-any-cooments'))}
                    </h2>
                </div>
                <div className="coment_form_content">
                    <form  onSubmit={ onFormSubmit }>
                        <div className="coment_form_contentInputs">
                            <input 
                                placeholder={(t('comments.name'))} 
                                name='Nombre' 
                                value={ Nombre }
                                onChange={ onInputChange }
                                required/>
                            <input 
                                placeholder={(t('comments.origin'))}
                                name='Procedencia'
                                value={ Procedencia }
                                onChange={ onInputChange }
                                />
                        </div>
                        <div className="coment_form_contentTextArea">
                            <input
                                type="email"
                                className="dropb escritorio input"
                                name="correo"
                                onChange={handleEmailChange}
                                value={correo}
                                placeholder={(t('comments.email'))}
                                required
                            />
                        </div>
                        <div className="coment_form_contentTextArea">
                            <textarea 
                                maxLength={1500} 
                                placeholder={(t('comments.share-your-idea'))}
                                name='Comentario'
                                value={Comentario}
                                onChange={e => {
                                        onInputChange(e);
                                        setCount(e.target.value.length);
                                        }
                                    }
                                    required>
                            </textarea>
                        </div>
                        <div className="coment_form_contentSend">
                            <a onClick={openReglasPopup} ><div dangerouslySetInnerHTML={{__html: (t('comments.show-rules'))}}></div></a>
                            { 
                                isLoading ?
                                (<span>Enviando...</span>) :
                                (<button id='btnsendi' type='submit' >{(t('comments.send'))}</button>)
                            }
                            <p>{count} / 1500 <br/>{(t('comments.characters'))}</p>
                        </div>
                        <ReglasPopup isOpen={isReglasPopupOpen} onClose={closeReglasPopup} />
                    </form>
                </div>
            </div>
    )
}
